import React from "react";
import { Button } from "antd";
// import { authContext } from "../../../config/adal";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../config/msal/authConfig";

const ErrorPage = ({ flag = false }): any => {
  const { instance, accounts, inProgress } = useMsal();

  function relogin() {
    // authContext.login();
    instance.loginRedirect(loginRequest).catch(e => {
      console.log(e);
    })
  }

  const no_role_assigned = "We couldn't find proper role assigned to you. Please contact your system admin. If you want to try with another credentials or after proper roleis assigned. Click the button.";
  const need_login = "You are currently not logged into the system. Click the login button to continue with the login. Be aware that only authorized users can use this MDM Business Partner Request App. If you need an authorization you can make an IT Service Request.";
      
  return (
    <div className="center-align">
      <p>{flag ? need_login : no_role_assigned}</p>
      <Button icon="login" type="primary" onClick={relogin}>
        Login
      </Button>
    </div>
  );
};
export default ErrorPage;
